import {paymentSvg as Icon__small__paymentSvg} from '../Icon__small/Icon__small--payment.js';

export var payment = {
  name: 'payment',
  category: 'icon',
  colorable: true,
  svg: Icon__small__paymentSvg,
};
